import {
  assignValue,
  assignProps,
  mapResults,
  findResultInCategory,
  selectableResultWithDates,
  findSelected,
} from '@/utils/resultsHelper';
import { responseError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import validateQuery from '@/cohorts/queries/helper';
import withDraft from '@/utils/draftHelper';
import actions from '../constants';
import { requestSources } from '../../constants';
import { findRequestSource } from '../../state/state';
import findRequestCohorts from './state';

const updateRequestQueries = withDraft((draft, action) => {
  const { item, source } = findRequestSource(draft, action);
  source.queries.forEach((query) => (
    assignProps(query, { selected: action.identifiers.includes(query.id) })
  ));
  item.isDirty = true;
});

const fetchRequestQueries = withDraft((draft, action) => {
  const { source } = findRequestSource(draft, action);
  source.code = action.cohortCode;
  source.readStatus = states.PENDING;
  source.readErrors = [];
});

const cohortToRequestError = withDraft((draft, action) => {
  const { item, cohorts } = findRequestCohorts(draft, action);
  item.request_source = requestSources.COHORT;
  cohorts.readStatus = states.ERROR;
  cohorts.readErrors = [responseError(action)];
});

const cohortToRequest = withDraft((draft, action) => {
  const { item, source } = findRequestSource(draft, action);
  item.request_source = requestSources.COHORT;
  const errors = [];
  action.result.forEach((query) => validateQuery(query, errors, true));

  assignProps(source, {
    queries: action.result.map((query) => ({ ...query, selected: action.names.includes(query.name) })),
    readStatus: states.SUCCESS,
    readErrors: [],
    validationErrors: errors,
  });
});

const fetchRequestCohorts = withDraft((draft, action) => {
  const { cohorts } = findRequestCohorts(draft, action);
  cohorts.readStatus = states.PENDING;
  cohorts.readErrors = [];
});

const showRequestCohorts = withDraft((draft, action) => {
  const { cohorts } = findRequestCohorts(draft, action);
  cohorts.readStatus = states.SUCCESS;
  cohorts.readErrors = [];
  cohorts.results = action.append
    ? mapResults(cohorts.results, action, selectableResultWithDates)
    : mapResults([], action, selectableResultWithDates);
  cohorts.pageSize = action.pageSize;
  cohorts.count = action.resultsCount;
  cohorts.currentPage = action.currentPage;
  cohorts.totalPages = action.totalPages;
});

const updateRequestCohortsFlags = withDraft((draft, action) => {
  const { cohorts } = findRequestCohorts(draft, action);
  cohorts.readStatus = states.PENDING;
  cohorts.readErrors = [];
  cohorts.privateFlag = action.privateFlag;
  cohorts.internalFlag = action.internalFlag;
  cohorts.currentPage = 1;
});

const updateRequestCohortsFilter = withDraft((draft, action) => {
  const { cohorts } = findRequestCohorts(draft, action);
  cohorts.filter = action.value;
});

const toggleRequestCohortSelected = withDraft((draft, action) => {
  const { cohorts } = findRequestCohorts(draft, action);
  const cohort = findResultInCategory(cohorts, action.cohortCode);
  const selectedCohorts = findSelected(cohorts.results);
  selectedCohorts.forEach((d) => assignValue(d, 'selected', false));
  cohort.selected = !cohort.selected;
});

export default {
  [actions.COHORT_TO_REQUEST]: cohortToRequest,
  [actions.COHORT_TO_REQUEST_ERROR]: cohortToRequestError,
  [actions.FETCH_REQUEST_COHORTS]: fetchRequestCohorts,
  [actions.FETCH_REQUEST_QUERIES]: fetchRequestQueries,
  [actions.SHOW_REQUEST_COHORTS]: showRequestCohorts,
  [actions.TOGGLE_REQUEST_COHORT_SELECTED]: toggleRequestCohortSelected,
  [actions.UPDATE_REQUEST_COHORTS_FLAGS]: updateRequestCohortsFlags,
  [actions.UPDATE_REQUEST_COHORTS_FILTER]: updateRequestCohortsFilter,
  [actions.UPDATE_REQUEST_QUERIES]: updateRequestQueries,
};
